import React, { Component } from 'react';
import withAuth from './../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import ViewLog from './../Components/Report/ViewLog';
import AdminIQAC from '../Components/AdminIQAC/AdminIQAC';

class IqacNewContainer extends Component {
    constructor(props) {
        super(props);
        let user = JSON.parse(localStorage.getItem('user')).user;

        this.state = {
            apikey: user.apikey,
            username: user.email,
            role: user.role
        }
    }
    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">

                    <AdminIQAC apikey={this.state.apikey} username={this.state.username} role={this.state.role} />

                </div>
            </div>
        )
    }
}

export default withAuth(IqacNewContainer);


// WEBPACK FOOTER //
// ./src/Containers/IqacNewContainer.js